module.exports = __webpack_public_path__ + "static/media/hourglass.4e4d70f4.svg";